import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useState } from "react"
import { useRestAPI } from "./axiosAPI"



export function useExportForcast({
    retryCount,
}: {
    retryCount?: number,
}) {

    const api = useRestAPI()
    const [totalSubAttributeCount, setTotalSubAttributeCount] = useState(0)
    const [validateProgress, setValidateProgress] = useState(0)
    const [uploadProgress, setuploadProgress] = useState(0)
    const queryclient = useQueryClient()
    // const [deleteRetryCount,setDeleteRetryCount] = useState(0)


    const { mutateAsync: downloadTemplateExportforecast, isPending: isDownloadingTEmplateExportforecast, failureCount: downloadTemplateFailureCount, isError: isDownloadExportforcastTemplateError } = useMutation({
        mutationFn: async ({
            date
        }:{date:string}) => {

            const response = await api.get({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/export-forecast/v2/template/`,
                params:{
                    date
                },
                mode: 'protected',
                responseType: 'blob'
            })


            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && downloadTemplateFailureCount < 4) {

                // setDeleteRetryCount((prev)=>prev+1)
                throw response
            }
            if (response.success !== false) {
                const blob = new Blob([response as unknown as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_forecast_template.xlsx'; // Set the filename

                // Append to the document and trigger the download
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }

            return response
        },
        retry: 4,

    })
    const { mutateAsync: validateExportforecastExel, isPending: isvalidateingExportforecastExel, failureCount: validateExportforecastExelFailureCount, isError: isvalidateExportforecastExelError } = useMutation({
        mutationFn: async ({ file }: { file: File }) => {

            const formData = new FormData();
            formData.append('file', file);

            const response = await api.post<{
                invalid_product_codes: string[],
                invalid_data: any[],
                invalid_style_codes: string[]
            },{}>({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/export-forecast/v2/template/validate/`,
                mode: 'protected',
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total!
                    );
                    setValidateProgress(percentCompleted);
                },
                data: formData
            });


            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && validateExportforecastExelFailureCount < 4) {

                // setDeleteRetryCount((prev)=>prev+1)
                throw response
            }


            return response
        },
        retry: 4,
        
    })

    const { mutateAsync: uploadExportforecastExel, isPending: isuploadingExportforecastExel, failureCount: uploadExportforecastExelFailureCount, isError: isuploadExportforecastExelError } = useMutation({
        mutationFn: async ({ file, date }: { file: File, date: string}) => {

            const formData = new FormData();
            formData.append('file', file);
            formData.append('date', date);
            const response = await api.post({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/export-forecast/v2/template/upload/`,
                mode: 'protected',
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total!
                    );
                    setuploadProgress(percentCompleted);
                },
                data: formData
            })


            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && uploadExportforecastExelFailureCount < 4) {

                // setDeleteRetryCount((prev)=>prev+1)
                throw response
            }


            return response
        },
        retry: 4,

    })



    return {

        downloadTemplateExportforecast,
        isDownloadingTEmplateExportforecast,
        isDownloadExportforcastTemplateError,
        validateExportforecastExel,
        isvalidateingExportforecastExel,
        isvalidateExportforecastExelError,
        validateProgress,
        uploadExportforecastExel,
        isuploadingExportforecastExel,
        isuploadExportforecastExelError,
        uploadProgress
    }


}




